import { render } from "./videoModal.vue?vue&type=template&id=ff5ced76&scoped=true"
import script from "./videoModal.vue?vue&type=script&lang=js"
export * from "./videoModal.vue?vue&type=script&lang=js"

import "./videoModal.vue?vue&type=style&index=0&id=ff5ced76&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5ced76"]])

export default __exports__